export default {
  "brand.name": "USFansSheet",
  "nav.home": "Accueil",
  "nav.categories": "Catégories",
  "nav.article": "Guides",
  "nav.faq": "FAQ",
  "nav.shoppingGuide": "Guide d'achat",
  "nav.guides": "Guides",
  "buttons.buyNow": "Acheter maintenant",
  "buttons.usfansSpreadsheet": "USFans Spreadsheet",
  "buttons.viewAll": "Voir toutes les catégories",
  "buttons.go": "Aller",
  "categories.shoes": "Chaussures",
  "categories.hoodies": "Hoodies / Pulls",
  "categories.tshirts": "T-shirts",
  "categories.jackets": "Vestes",
  "categories.pants": "Pantalons / Shorts",
  "categories.headwear": "Couvre-chefs",
  "categories.sets": "Ensembles",
  "categories.underwear": "Sous-vêtements / Boxers",
  "categories.jersey": "Maillot de sport",
  "categories.accessories": "Accessoires",
  "categories.bags": "Sacs",
  "categories.belts": "Ceintures",
  "categories.perfumes": "Parfums",
  "categories.other": "Autres articles",
  "footer.disclaimer": "USFansSheet est une ressource d'information indépendante. Les informations peuvent évoluer avec le temps. Vérifiez toujours de manière indépendante les informations actuelles sur les produits, les vendeurs, la livraison, les paiements et les promotions avant de prendre une décision.",
  "footer.rights": "Tous droits réservés.",
  "footer.explore": "Explorer",
  "footer.categories": "Catégories",
  "footer.resources": "Ressources",
  "footer.backHome": "Retour à l'accueil",
  "pillar.title": "Guides principaux",
  "pillar.subtitle": "Découvrez nos guides approfondis sur la recherche USFans, le QC, la livraison, la sécurité et bien plus.",
  "pillar.readMore": "Lire le guide",
  "published": "Publié",
  "updated": "Mis à jour",
  "readingTime": "min de lecture",
  "backHome": "Retour à l'accueil",
  "breadcrumbHome": "Accueil",
  "breadcrumbCurrent": "Guide",
  "notFound.title": "Guide introuvable",
  "notFound.back": "Retour à l'accueil",
  "tag.beginner": "Guide pour débutants",
  "tag.research": "Guide de recherche",
  "tag.qc": "Guide QC",
  "tag.shipping": "Guide de livraison",
  "tag.warehouse": "Guide d'entrepôt",
  "tag.safety": "Guide de sécurité",
  "tag.categories": "Guide des catégories",
  "tag.compare": "Guide de comparaison",
  "tag.coupon": "Guide des coupons",
  "tag.seller": "Guide des vendeurs",
};